import { createContext } from "react";


export const RegisterContext = createContext();
